import React from "react";
import { Grid, List, Checkbox, FormControlLabel, Box } from "@mui/material";
import RegionsSideBarListItem from "./RegionsSideBarListItem";

const RegionsSideBarTransferList = ({
  items,
  handleToggle,
  checked,
  onSelectAll,
}) => {
  // Filter items to only include categories with R&D members (non-empty members array)
  const itemsWithMembers = items.filter(
    (item) => item.members && item.members.length > 0
  );

  // Check if all items with members are selected
  const allSelected = itemsWithMembers.length > 0 && checked.length === itemsWithMembers.length;
  const someSelected = checked.length > 0 && checked.length < itemsWithMembers.length;

  // Handle Select All toggle - only selects categories with R&D members
  const handleSelectAllToggle = (event) => {
    if (event.target.checked) {
      // Select all items that have R&D members
      if (onSelectAll) {
        onSelectAll(itemsWithMembers);
      } else {
        // Fallback: toggle each item individually
        itemsWithMembers.forEach(item => {
          if (!checked.includes(item)) {
            handleToggle(item);
          }
        });
      }
    } else {
      // Deselect all items
      if (onSelectAll) {
        onSelectAll([]);
      } else {
        // Fallback: toggle each checked item
        checked.forEach(item => handleToggle(item));
      }
    }
  };

  return (
    <Grid item xs={12}>
      {/* Select All Categories Checkbox - only shown if there are categories with members */}
      {itemsWithMembers.length > 0 && (
        <Box sx={{ mb: 1, ml: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={allSelected}
                indeterminate={someSelected}
                onChange={handleSelectAllToggle}
                color="primary"
                size="small"
              />
            }
            label={`Select All Categories (${checked.length}/${itemsWithMembers.length})`}
          />
        </Box>
      )}
      <List dense component="div" role="list" className="regionsPanel">
        {/* Only display categories that have R&D members */}
        {itemsWithMembers.map((value, index) => (
          <RegionsSideBarListItem
            key={index}
            category={value}
            handleToggle={handleToggle}
            checked={checked.indexOf(value) !== -1}
          />
        ))}
      </List>
    </Grid>
  );
};

export default RegionsSideBarTransferList;
